import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { loadScript } from 'wanderu-utils';

import { GoogleSDKFailedToLoadError } from '../../Errors';

const logger = Logger.getLogger('GoogleOneTapSdkLoader');

async function ensureSdkLoaded(credsCallback) {
    if (window.google) {
        return;
    }

    try {
        await loadScript(appSettings.config.google.oneTapUrl);
        window.google.accounts.id.initialize({
            client_id: appSettings.config.google.clientId,
            auto_select: true,
            use_fedcm_for_prompt: true,
            callback: (...args) => {
                credsCallback(...args);
            },
        });
    } catch (ex) {
        logger.error('LoadSDK', 'Google One Tap SDK failed to load', ex);
        throw new GoogleSDKFailedToLoadError();
    }
}

export {
    ensureSdkLoaded,
};
